<!-- ANCHOR: Intents Reference Panel -->
<dialog
  #dialogEl
  class="instructions-dialog"
  [attr.aria-label]="'chatbot.overlay-intents-title' | translate"
  aria-modal="true"
  (click)="onDialogClick($event, dialogEl)"
  (cancel)="onCancel($event)"
>
  <!-- Header -->
  <div class="instructions-dialog__header">
    <div class="instructions-dialog__title">
      <i class="fas fa-lightbulb" aria-hidden="true"></i>
      {{ 'chatbot.overlay-intents-title' | translate }}
    </div>
    <p class="instructions-dialog__subtitle">{{ 'chatbot.overlay-intents-subtitle' | translate }}</p>
    <button
      type="button"
      class="instructions-dialog__close"
      [attr.aria-label]="'chatbot.aria-close' | translate"
      (click)="close()"
    >
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </div>

  <!-- Body -->
  <div class="instructions-dialog__body">
    <div class="intents-view">

      <!-- Search filter -->
      <input
        type="search"
        class="intents-view__filter"
        [placeholder]="'chatbot.instructions.intents-filter' | translate"
        [value]="intentFilter()"
        (input)="intentFilter.set(getInputValue($event))"
        autocomplete="off"
      />

      <!-- Count -->
      <p class="intents-view__count-info">
        {{ filteredIntents().length }} {{ 'chatbot.instructions.all-intents-heading' | translate }}
      </p>

      <!-- Full intent list -->
      <ul class="intents-list">
        @for (row of filteredIntents(); track row.id) {
          <li class="intent-row">

            <!-- Title row: human-readable label + action badge -->
            <div class="intent-row__header">
              <span class="intent-row__title">{{ row.humanLabel }}</span>
              <span class="intent-row__action-badge intent-row__action-badge--{{ row.action.toLowerCase() }}">
                {{ row.actionKey | translate }}
              </span>
            </div>

            <!-- Technical id + route payload -->
            <div class="intent-row__meta">
              <code class="intent-row__id">{{ row.id }}</code>
              @if (row.action === ChatAction.NAVIGATE && row.payload) {
                <span class="intent-row__arrow">→</span>
                <code class="intent-row__payload">{{ row.payload }}</code>
              }
            </div>

            <!-- Description -->
            @if (row.description) {
              <div class="intent-row__description">
                <i class="fas fa-info-circle" aria-hidden="true"></i>
                {{ row.description }}
              </div>
            }

            <!-- Usage examples — clickable to copy the text directly into the chat input -->
            @if (row.examples.length > 0) {
              <div class="intent-row__examples">
                @for (ex of row.examples; track ex) {
                  <button
                    type="button"
                    class="intent-row__example-chip"
                    [title]="ex"
                    (click)="onExampleClick(ex)"
                  >
                    <i class="fas fa-comment-dots" aria-hidden="true"></i>{{ ex }}
                  </button>
                }
              </div>
            }

            <!-- Patterns toggle -->
            <div class="intent-row__footer">
              <button
                type="button"
                class="intent-row__patterns-toggle"
                (click)="togglePatterns(row.id)"
              >
                <i class="fas fa-code" aria-hidden="true"></i>
                {{ 'chatbot.instructions.intent-patterns' | translate : { count: row.patternCount } }}
                <i
                  class="fas"
                  [class.fa-chevron-down]="!expandedPatternIds().has(row.id)"
                  [class.fa-chevron-up]="expandedPatternIds().has(row.id)"
                  aria-hidden="true"
                ></i>
              </button>
            </div>

            <!-- Expanded patterns list -->
            @if (expandedPatternIds().has(row.id)) {
              <div class="intent-row__patterns-list">
                @for (pattern of row.patterns; track pattern) {
                  <code class="intent-row__pattern">{{ pattern }}</code>
                }
              </div>
            }

          </li>
        }
      </ul>

    </div>
  </div>
</dialog>
